import React from "react";
import "./VoiceRecordingConsent.scss";

/**
 * Renders the voice recording consent message below the booking button for applicable locations.
 */
export const VoiceRecordingConsent: React.FC = () => {
    return (
        <div className="voice-recording-consent-container">Safe Transport Victoria require Taxis to record audio and video.</div>
    );
}